<template>
  <div class="document-container">
    <div v-if="!saved && !readOnly" class="row">
      <div class="col-md-8 pt-0">
        <label class="input-display d-block">
          Documento:
        </label>
        <span class="text-format">Plan de Intervención Firmado</span>
      </div>
      <div class="col-md-4">
        <validation-provider
          v-slot="{ errors }"
          name="Archivo"
          rules="required"
        >
          <custom-file-input
            ref="attachedDocument"
            v-model="document"
            :accept="allowedFiles"
            custom-error-msg="Favor de anejar el documento."
            display-style="normal"
            :error="errors[0]"
            label="Archivo:"
            label-position="left"
            required
          />
        </validation-provider>
      </div>
      <div class="col-12 mt-3 mt-md-2 d-flex justify-content-end">
        <action-button
          i="fas fa-times-circle"
          text="Cancelar"
          variant="outline-danger mr-3"
          @click="cancel"
        />

        <action-button
          i="fa fa-file-plus"
          text="Añadir"
          variant="success"
          @click="saveDocument"
        />
      </div>
    </div>
    <div v-else class="row align-items-center">
      <div class="col-12 col-md-10">
        <label class="input-display d-block">
          Plan de Intervención Firmado:
        </label>
        <span v-if="data" class="text-format">{{ data.name }}</span>
      </div>
      <div v-if="!readOnly" class="col-12 col-md-2 text-right">
        <drop-down class="documents-action" :items="actionItems" />
      </div>
    </div>
  </div>
</template>

<script>
import ActionButton from 'ActionButton';
import DropDown from 'dropdown';
import CustomFileInput from '@/components/common/CustomFileInput';
import _generalApi from '@/modules/app/api';

export default {
  name: 'InterventionPlanDocument',
  components: {
    ActionButton,
    DropDown,
    CustomFileInput,
  },
  props: {
    data: {
      type: Object,
      default: () => null,
    },
    readOnly: {
      type: Boolean,
      default: () => false,
    },
    saved: {
      type: Boolean,
      default: () => false,
    },
  },
  data: () => ({
    document: null,
    allowedFiles: '.pdf',
  }),
  computed: {
    actionItems() {
      return [
        {
          name: 'edit',
          label: 'Editar',
          icon: 'fas fa-edit color-primary-1',
          click: () => this.editDocument(),
          visible:
            (!this.data.documentId ||
              (this.data.documentId &&
                this.userHasPermissions(
                  'interventionplan.canchangedocument'
                ))) &&
            !this.readOnly,
        },
        {
          btnClass: 'outline-success',
          icon: 'fas fa-file-download color-primary-1',
          label: 'Descargar',
          visible: this.data.documentId != null,
          click: () => this.downloadFile(),
        },
      ];
    },
  },
  methods: {
    saveDocument() {
      this.$emit('save-document', this.document);
    },
    editDocument() {
      this.$emit('edit-document');
    },
    cancel() {
      if (this.data && this.data.documentId) {
        this.document = this.data.file;
        this.$emit('cancel-document', true);
        return;
      }
      this.document = null;
      this.$emit('cancel-document', false);
    },
    async downloadFile() {
      await _generalApi
        .downloadDocumentByAttachmentId(this.data.documentId)
        .catch(() => {
          this.ShowToast('', 'El documento no existe.', 'error');
        });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/shared/scss/config/colors.scss';

.document-container {
  padding: 0 0.8rem;
  ::v-deep &__text-area {
    .small-counter {
      font-size: 0.8rem;
      color: map-get($colors, 'gray-6');
    }
  }

  .input-display {
    font-size: 0.875rem;
    color: map-get($colors, 'gray-6');
    font-weight: bold;
  }

  .text-format {
    overflow-wrap: break-word;
    text-align: justify;
  }

  @media only screen and (max-width: 768px) {
    ::v-deep .documents-action {
      .btn {
        margin-top: 0.8rem;
        width: 100%;
      }
    }
  }
}
</style>
